import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BackendService,
  HttpOptions,
} from '@ipg/ngx-frontend-toolset';
import { SignalingBlock, SignalingBlockCreateRequest } from '../client-signaling.model';

@Injectable({
  providedIn: 'root',
})
export class ClientSignalingService {
  private readonly _backend = inject(BackendService);

  get(clientId: string, scmId: string): Observable<SignalingBlock> {
    return this._backend.get(`/clients/${clientId}/signaling/${scmId}`);
  }

  getAll(clientId: string): Observable<SignalingBlock[]> {
    return this._backend.get(`/clients/${clientId}/signaling`);
  }

  create(
    clientId: string,
    data: SignalingBlockCreateRequest,
    options?: HttpOptions
  ): Observable<string> {
    return this._backend.post(`/clients/${clientId}/signaling`, data, options);
  }

  delete(clientId: string, scmId: string, options?: HttpOptions) {
    return this._backend.delete(`/clients/${clientId}/signaling/${scmId}`, options);
  }

  updateActive(clientId: string, scmId: string, data: unknown, options?: HttpOptions) {
    return this._backend.put(
      `/clients/${clientId}/signaling/${scmId}/active`,
      data,
      options
    );
  }

  updateAvatar(clientId: string, scmId: string, data: unknown, options?: HttpOptions) {
    return this._backend.put(
      `/clients/${clientId}/signaling/${scmId}/avatar`,
      data,
      options
    );
  }

  updateConfig(clientId: string, scmId: string, data: unknown, options?: HttpOptions) {
    return this._backend.put(
      `/clients/${clientId}/signaling/${scmId}/config`,
      data,
      options
    );
  }

  addReference(clientId: string, scmId: string, data: unknown, options?: HttpOptions) {
    return this._backend.post(
      `/clients/${clientId}/signaling/${scmId}/reference`,
      data,
      options
    );
  }

  deleteReference(
    clientId: string,
    scmId: string,
    linkId: string,
    options?: HttpOptions
  ) {
    return this._backend.delete(
      `/clients/${clientId}/signaling/${scmId}/reference/${linkId}`,
      options
    );
  }
}
